// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchStats_container__zt6fE"};